<app-header *ngIf="showNav" [showNavigation]="showNavigation"></app-header>
<div id="contentPage" class="d-flex" [ngClass]="[(layout.isScreenSmall$ | async) ? mobileLayoutClass : layoutClass]">
  <app-sidenavbar *ngIf="showNav && showSideNav && !(layout.isScreenSmall$ | async)"></app-sidenavbar>
  <div class="d-flex flex-column flex-grow-1 justify-content-between" style="max-width: 100%">
    <div class="main-content-fix" [ngClass]="{ 'h-100 no-nav': !showNav }" [ngStyle]="{ 'padding-left': showNav && showSideNav && !(layout.isScreenSmall$ | async) ? '50px' : '0' }">
      <ng-content></ng-content>
    </div>
    <app-footer *ngIf="showFooter"></app-footer>
    <div *ngIf="!isPublicPage && (layout.isScreenSmall$ | async) && showNav" class="mt-3" style="height: 80px">
      <app-bottom-navigation-bar></app-bottom-navigation-bar>
    </div>
  </div>
</div>
